import {
  Accordion,
  AccordionDetails,
  AccordionSummary
} from '@mui/material';
import TextArea from 'antd/es/input/TextArea';
import Once from '../../../components/Layout/Wrappers/Once';
import {
  join,
  sanitizeArr
} from '../../Array.lib';
import useState from '../../hooks/useState.hook';
import {
  Str
} from '../../String.lib';
import fetchResumeHighlightsNonComplexTasksList from './fetchResumeHighlightsNonComplexTasksList.fun';
import {
  KEY__RESUME_HIGHLIGHTS__NON_COMPLEX_TASKS_LIST
} from './getDefaultModelResumeHighlights.fun';
import upsertResumeHighlightsList from './upsertResumeHighlightsNonComplexTasksList.fun';

export default function AccordionResumeHighlights({
  ...props
}) {
  const [state, updateState] = useState();
  const VALUE__NON_COMPLEX_TASKS_LIST = Str(state[KEY__RESUME_HIGHLIGHTS__NON_COMPLEX_TASKS_LIST]);

  const onChange = (attribute) => {
    return event => {
      updateState({
        [attribute]: event.target.value
      });
    }
  }

  const onBlur = (attribute) => {
    return async (event) => {
      const list = sanitizeArr(Str(event.target.value).split(/\n|,/)).sort();
      updateState({ [attribute]: list.join('\n') });
      upsertResumeHighlightsList({ attribute, list });
    }
  }
  return (
    <Accordion
      {...props}
    >
      <AccordionSummary
        expandIcon={<i className='material-icons'>expand_more</i>}
        aria-controls="panel1bh-content"
        id="panel1bh-header"
      >
        <strong className='f-xl c-black'>
          Resume Highlights
        </strong>
        <Once
          promise={async () => updateState({
            [KEY__RESUME_HIGHLIGHTS__NON_COMPLEX_TASKS_LIST]: join(
              await fetchResumeHighlightsNonComplexTasksList(), '\n'
            )
          })}
        />
      </AccordionSummary>
      <AccordionDetails className='overflow-hidden'>
        <div className='d-flex flex-wrap'>
          <div className='flex-column flex-1 mr-1' style={{ minWidth: 160 }}>
            <strong className='f-lg c-cyan-darker'>Non complex tasks</strong>
            <small className='c-black-medium truncate'>Keywords to highlight as non-complex tasks from resume text</small>
            <TextArea
              placeholder='Type here'
              value={VALUE__NON_COMPLEX_TASKS_LIST}
              autoSize={{ minRows: 1, maxRows: 12 }}
              onChange={onChange(KEY__RESUME_HIGHLIGHTS__NON_COMPLEX_TASKS_LIST)}
              onBlur={onBlur(KEY__RESUME_HIGHLIGHTS__NON_COMPLEX_TASKS_LIST)}
            />
          </div>
        </div>
      </AccordionDetails>
    </Accordion>
  );
}
